<template>
  <div class="page-cate">
    <Navigation title="分类" />
    <div class="content-wrap">
      <div class="cate-sidebar">
        <md-scroll-view ref="sidebarScrollView" :scrolling-x="false">
          <ul>
            <li
              class="sidebar-item"
              v-for="tabItem in tabList"
              :key="tabItem.tabId"
              @click="handleClickTab(tabItem.tabId)"
            >
              <div
                class="sidebar-text"
                :class="{active: curTabId === tabItem.tabId}"
              >{{tabItem.tabName}}</div>
            </li>
          </ul>
        </md-scroll-view>
      </div>
      <div class="cate-wrap">
        <md-scroll-view ref="cateScrollView" :scrolling-x="false">
          <ul class="cate-list">
            <li
              class="cate-item"
              v-for="tabCateItem in tabCateList"
              :key="tabCateItem.cateId"
              @click="handleClickCateGoodsList(tabCateItem)"
            >
              <img class="cate-img" :src="formatHttpImg(tabCateItem.cateImg)" />
              <span class="cate-text">{{tabCateItem.cateName}}</span>
            </li>
          </ul>
        </md-scroll-view>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import { ScrollView } from 'mand-mobile'
export default {
  name: 'cate',
  components: {
    Navigation,
    [ScrollView.name]: ScrollView,
  },
  data() {
    return {
      channel: '',
      sidebarScrollTop: 0,
      cateScrollTop: 0,
      curTabId: -1,
      tabList: [],
      tabCateList: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let AlivePages = ['productList']
      if (from.name === null || AlivePages.indexOf(from.name) === -1) {
        vm.fetchTabList()
      } else {
        vm.$_setScrollPosition()
      }
    })
  },
  deactivated() {
    this.sidebarScrollTop = this.$refs.sidebarScrollView.getOffsets().top
    this.cateScrollTop = this.$refs.cateScrollView.getOffsets().top
  },
  methods: {
    /**
     * 设置滚动距离
     */
    $_setScrollPosition() {
      this.$nextTick(() => {
        const sidebarScrollVM = this.$refs.sidebarScrollView
        if (sidebarScrollVM && this.sidebarScrollTop > 0) {
          setTimeout(() => {
            sidebarScrollVM.scrollTo(0, this.sidebarScrollTop, false)
            sidebarScrollVM.reflowScroller()
          }, 50)
        }
        const cateScrollVM = this.$refs.cateScrollView
        if (cateScrollVM && this.cateScrollTop > 0) {
          setTimeout(() => {
            cateScrollVM.scrollTo(0, this.cateScrollTop, false)
            cateScrollVM.reflowScroller()
          }, 50)
        }
      })
    },
    /**
     * 点击tab菜单
     */
    handleClickTab(tabId) {
      if (this.curTabId !== tabId) {
        this.curTabId = tabId
        this.fetchTabCateAllList()
      }
    },
    /**
     * tab菜单
     */
    fetchTabList() {
      this.channel = this.$route.query.channel || 'tbk'
      this.curTabId = -1
      this.tabList = []
      this.tabCateList = []
      this.$http[this.channel].tabList().then(res => {
        this.tabList = res.data
        this.curTabId = res.data[0].tabId
        this.$nextTick(() => {
          this.$refs.sidebarScrollView.reflowScroller()
        })
        this.fetchTabCateAllList()
      })
    },
    /**
     * tab菜单对应的分类
     */
    fetchTabCateAllList() {
      this.$http[this.channel].tabCateAllList(this.curTabId).then(res => {
        this.tabCateList = res.data
        this.$nextTick(() => {
          this.$refs.cateScrollView.reflowScroller()
        })
      })
    },
    /**
     * 点击跳转分类对应的商品列表
     */
    handleClickCateGoodsList(cateItem) {
      this.$router.push({ name: 'productList', query: { channel: this.channel, type: 'cate', id: cateItem.cateId, title: cateItem.cateName } })
    },
  },
}
</script>

<style  lang="scss" scoped>
.page-cate {
  position: relative;
  height: 100%;
  .content-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0.88rem;
    border-top: 1px solid #eee;
    .cate-sidebar {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 2rem;
      box-shadow: inset -1px 0 0 0 #eee;
      .sidebar-item {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1rem;
        .sidebar-text {
          font-size: 0.28rem;
          width: 1.56rem;
          height: 0.65rem;
          line-height: 0.65rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #111;
          text-align: center;
          &.active {
            padding: 0 0.2rem;
            border-radius: 0.7rem;
            background: rgba(255, 30, 50, 1);
            color: #fff;
          }
        }
      }
    }
    .cate-wrap {
      position: absolute;
      left: 2rem;
      right: 0.15rem;
      top: 0;
      bottom: 0;
      padding: 0 0.2rem;
      .cate-list {
        padding-top: 0.3rem;
      }
      .cate-item {
        width: 32.8%;
        float: left;
        text-align: center;
        .cate-img {
          width: 1rem;
          height: 1rem;
          vertical-align: middle;
        }
        .cate-text {
          position: relative;
          z-index: 2;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 0.24rem;
          color: #666;
          height: 0.7rem;
          margin-top: 0.2rem;
        }
      }
    }
  }
}
</style>